import ToollBar from "./Toollbar";
import ListBoard from './ListBoard';
import { IOccurrence } from "../types";

interface Props {
    data: IOccurrence[];
    handleSearch: (text: string) => void;
    handleDn: (text: string) => void;
    handleResponsible: (text: string) => void;
    handleSubject: (subject: string) => void;
    isLoading: boolean;
}

const SupportBoard = ({data, handleSearch, handleSubject, handleDn, handleResponsible, isLoading}: Props) => {
    return (
        <div>
            <ToollBar handleSearch={handleSearch} handleSubject={handleSubject} handleDn={handleDn} handleResponsible={handleResponsible} />
            <ListBoard data={data} isLoading={isLoading} />
        </div>
    )
}

export default SupportBoard;